import { render, staticRenderFns } from "./GeneralSettingsEnableFooter.vue?vue&type=template&id=9da1e7d6&scoped=true&"
import script from "./GeneralSettingsEnableFooter.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingsEnableFooter.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingsEnableFooter.vue?vue&type=style&index=0&id=9da1e7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da1e7d6",
  null
  
)

export default component.exports